import { useCallback, useEffect, useMemo } from 'react';

import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FeatureProvider: FunctionComponent<Props> = ({ children, testId = TEST_ID }) => {
    const growthbookInstance = useMemo(
        () =>
            new GrowthBook({
                apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
                clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
                enableDevMode: import.meta.env.DEV,
                subscribeToChanges: true
            }),
        []
    );

    const loadFeatures = useCallback(
        async ({
            organizationId,
            userId
        }: {
            organizationId?: string | null;
            userId?: string | null;
        }) => {
            const growthbookAttributes = {
                id: userId,
                organizationId: organizationId
            };

            growthbookInstance.setAttributes(growthbookAttributes);

            await growthbookInstance.loadFeatures();
        },
        [growthbookInstance]
    );

    useEffect(() => {
        loadFeatures({
            organizationId: '1',
            userId: '1'
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <GrowthBookProvider data-testid={testId} growthbook={growthbookInstance}>
            {children}
        </GrowthBookProvider>
    );
};

export default FeatureProvider;
